<template>
    <section class="my-4 mx-4">
        <div class="border border-gray-light p-4 rounded-md text-center shadow">
            <small class="uppercase">
                Ambassador Link
            </small>
            <p class="text-xl font-bold">{{ link }}</p>
            <a href class="text-xs text-primary" @click.prevent="copyAmbassadorLink">
                <font-awesome-icon :icon="['fas', 'copy']"></font-awesome-icon>
                <span>{{ copyText }}</span>
            </a>
        </div>
    </section>
</template>

<script>

const TEXT_COPY_DEFAULT = 'COPY';
const TEXT_COPY_SUCCESS = 'COPIED!';

export default {
    data() {
        return {
            link    : window.User.ambassador_link,
            copyText: TEXT_COPY_DEFAULT,
        }
    },
    methods: {
        copyAmbassadorLink() {
            this.$copyText(this.link).then(() => {
                this.copyText = TEXT_COPY_SUCCESS;
                
                // back to default text after some time
                setTimeout(() => {
                    this.copyText = TEXT_COPY_DEFAULT;
                }, 3000);
            });
        },
    }
}
</script>

<style>

</style>